import { render } from "./CheckMark.vue?vue&type=template&id=3821068e"
import script from "./CheckMark.vue?vue&type=script&lang=js"
export * from "./CheckMark.vue?vue&type=script&lang=js"
script.render = render

export default script